import React from "react";
function Footer() {
  return (
    <footer>
      <p>Copyright &copy; Llewellyn and Shafer, PLLC. 2020</p>
    </footer>
  );
}

export default Footer;
